// extracted by mini-css-extract-plugin
module.exports = {"blogpost":"single-blog-module--blogpost--2fKPw"};